<form class="club-form" [class.club-form-page]="variant === 'page'" (ngSubmit)="submit()">
  <div class="input-group" [class.input-group-page]="variant === 'page'">
    <input
      type="email"
      name="email"
      [(ngModel)]="email"
      placeholder="Ingresa tu correo"
      class="minimal-input"
      [class.minimal-input-page]="variant === 'page'"
      autocomplete="email"
      [disabled]="submitting"
    />
    <button type="submit" class="minimal-btn" [class.minimal-btn-page]="variant === 'page'" [disabled]="submitting">
      {{ submitting ? '…' : '→' }}
    </button>
  </div>

  <label class="opt-in" [class.opt-in-page]="variant === 'page'">
    <input type="checkbox" [(ngModel)]="optIn" name="optIn" [disabled]="submitting" />
    <span>Quiero recibir novedades de Moanani</span>
  </label>

  <p class="disclaimer" [class.disclaimer-page]="variant === 'page'">
    Sé el primero en enterarte de drops y noticias.
  </p>
</form>